import { Grid } from '@material-ui/core';
import { contratoApi } from 'app/services/api/contratoApi';
import React from 'react';

const AnexoContratoVisualizacao = ({ anexos }) => {
  const onDownload = async (anexo) => {
    const response = await contratoApi().downloadAnexo(anexo.id);
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', anexo.nome);
    document.body.appendChild(link);
    link.click();
  };

  return (
    <Grid container spacing={3}>
      {anexos?.map((anexo) => (
        <Grid item xs={12}>
          <p className="mb-4">
            <button type="button" style={{ color: '#53c4e6', fontSize: 15 }} onClick={() => onDownload(anexo)}>
              {anexo.nome}
            </button>
          </p>
        </Grid>
      ))}
    </Grid>
  );
};

export default AnexoContratoVisualizacao;
